export default __webpack_public_path__ + "static/media/startTin.52ddd5d7.png";